export default "__VITE_ASSET__Bw0TAtvD__"